import { combineReducers } from "redux";
import vendorBillApprove from "./vendorBillApprove";
import vendorBills from "./vendorBills/vendorBills";
import contracts from "./contracts";
import contacts from "./contacts";
import contactstypes from "./contactstypes";
import roles from "./roles";
import amenities from "./amenities";
import account from "./account";
import trust_center from "./trust_center";
import invoices from "./invoices";
import vendors from "./vendors";
import orders from "./orders";
import orderlineitems from "./orderlineitems";
import groups from "./groups";
import tasks from "./tasks";
import alert from "./alert";
import logs from "./logs";
import permissions from "./permissions/permissions";
import reports from "./reports";
import videos from "./videos";
import accountCodes from "./accountCodes";
import title from "./dashboards/title";
import customerService from "./dashboards/customer-service";
import preseizure_packages from "./preseizure_packages";

import activities from "../reducers/activities";

// NAME: Properties State
import properties from "./properties/properties";
import propertyBudget from "./properties/budget";
import propertyDisposition from "./properties/disposition";
import propertyLiens from "./properties/liens";
import propertyManagement from "./properties/management";
import propertyMarketing from "./properties/marketing";
import propertyAmenities from "./properties/amenities";
import propertyContacts from "./properties/contacts";
import propertyTitle from "./properties/title";
import propertyFiles from "./properties/files";
import propertyNotes from "./properties/notes";
import propertyVideos from "./properties/videoManager";

//  NAME: Automobile State
import automobiles from "./automobiles/automobiles";
import automobileAdd from "./automobiles/add";
import automobilePhotos from "./automobiles/photos";
import automobileMarketing from "./automobiles/marketing";
import automobileCondition from "./automobiles/condition";

//  NAME Tangible STate
import tangibles from "./tangibles";

import leases from "./leases";

//  NAME: MISC
import MISC from "./misc";
import myDropzone from "./myDropzone";
import confirmModal from "./modals/confirm";
import datatable from "./datatable";
import error from "./error";
import reduxConfirmModal from './reduxConfirmModal';

// NAME: tabs
import fileTree from "./fileTab/fileTree";
import photoTab from "./photoTab";

//  NAME Intangible State
import intangibles from "./intangibles";

// Asset Associations
import assetAssociations from "./associations";

export default combineReducers({
    vendorBillApprove,
    vendorBills,
    permissions,
    contracts,
    contacts,
    contactstypes,
    roles,
    amenities,
    account,
    trust_center,
    invoices,
    vendors,
    orders,
    orderlineitems,
    groups,
    tasks,
    alert,
    logs,
    reports,
    videos,
    accountCodes,
    title,
    customerService,
    preseizure_packages,
    //  NAME: Properties
    properties,
    propertyBudget,
    propertyDisposition,
    propertyLiens,
    propertyManagement,
    propertyMarketing,
    propertyAmenities,
    propertyContacts,
    propertyFiles,
    propertyNotes,
    propertyTitle,
    propertyVideos,
    //  NAME: Automobiles
    automobiles,
    automobileAdd,
    automobilePhotos,
    automobileCondition,
    automobileMarketing,
    //  NAME: Tangibles
    tangibles,
    intangibles,
    leases,
    //  NAME: MISC
    MISC,
    myDropzone,
    confirmModal,
    datatable,
    activities,
    error,
    //	NAME: Tabs
    fileTree,
    photoTab,
    assetAssociations,
    reduxConfirmModal
});
